export default "__VITE_ASSET__88a06b8d__"